import * as React from 'react';

import * as styles from './orientation-toggle.less';
import { classNames } from '../../../../Shared/utils/classnames';

export enum OrientationType {
	Landscape = 'Landscape',
	Full = 'Full',
}

export const OrientationToggle = ({ value }: { value: string }) => {
	const indicator = classNames({
		[styles.orientationToggleLandscape]: value === OrientationType.Landscape.toString(),
		[styles.orientationToggleFull]: value === OrientationType.Full.toString(),
	});

	return (
		<span className={styles.orientationToggleInner}>
			<span className={indicator}></span>
		</span>
	);
};
